import React, { useState, useEffect, useRef } from 'react';

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from '../mensajes';
import axios from 'axios';
import { Dimmer } from '../spinner';

import { PartidasExtras } from './modalPartidasExtras';


const TablaPartidasExtras = (props) => {

  var op = require('../../../src/modulos/datos')
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

  const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'ORDINAL', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CATEGORIA', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
    { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'UBICACIÓN', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]


  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [presupuesto, setPresupuesto] = useState();
  const [claspre, setClaspre] = useState();
  const [presupuestot, setPresupuestot] = useState([]);
  const txtBuscador = useRef()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {

            if (x.categoria.includes(target.value)
              || x.auxiliar.toLowerCase().includes(target.value.toLowerCase())
              || x.descripcionaux.toLowerCase().includes(target.value.toLowerCase())
              || x.sectorgeog.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })

  }

  const SeleccionarRegistros = () => {

    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/registrospartidasextras?idefiscal=${idefiscal}`
    console.log(endpoint)
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {
        setRecords(response.data);
        txtBuscador.current.focus()
      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const SeleccionarPresupuesto = (id, aux) => {

    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarctasobrasid?proyecto=${id}&auxiliar=${aux}&idefiscal=${idefiscal}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.proyecto > 0) {
          setPresupuesto(response.data);
          SeleccionarPresupuestoTabla(id, aux);
        } else {
          setPresupuesto([]);
          SeleccionarPresupuestoTabla(id, aux);
        }

      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const SeleccionarPresupuestoTabla = (id, aux) => {

    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/selectclassobrastabla?proyecto=${id}&auxiliar=${aux}&idefiscal=${idefiscal}`
    console.log(endpoint);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.lenght !== '') {
          setPresupuestot(response.data);
          SeleccionarClassificadorIva(id, aux);
        } else {
          setPresupuestot([]);
          SeleccionarClassificadorIva(id, aux);
        }

      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const SeleccionarClassificadorIva = (id, aux) => {

    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/selectclassobras?proyecto=${id}&auxiliar=${aux}&idefiscal=${idefiscal}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.proyecto > 0) {
          setClaspre(response.data);
          setMostrar2(true);
        } else {
          setClaspre([]);
          setMostrar2(true);
        }

      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const handleCloseSi = () => {

    setActivate(false);

  };

  const gestionarCtaPresupuestaria = (op, id, aux) => (e) => {

    if (op === 4) {
      setOperacion(4);
      SeleccionarPresupuesto(id, aux);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true)
    } else if (op === 2) {
      setOperacion(op);
      SeleccionarPresupuesto(id, aux);
    } else if (op === 3) {
      setOperacion(op);
      SeleccionarPresupuesto(id, aux);
    }

  }


  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  }

  const cerrar = () => {
    props.menu()
  }

  return (
    <section className='modal-azulGradiant mx-auto col-9'>


      <header className='header-azulGradiant'>
        <h3 >
          Partidas Extras
        </h3>
        <a type='button' onClick={cerrar}>
          salir<i className="fas fa-times"></i>
        </a>
      </header>
      <div className="form-azulGradiant px-2">
        <input type="text" className="search-input col-3 form-control form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />
        <button onClick={gestionarCtaPresupuestaria(1, '')} style={{ marginBottom: "5px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>

      </div>



      <div className="col-md-12 m-0" >
        <TblContainer>
          <TblHead />
          <tbody>
            {
              records && recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index + item.proyecto} style={{ padding: "0" }}>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '30px' }}>{item.auxiliar}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '30px' }}>{item.categoria}</td>
                  <td className='align-middle' style={{ textAlign: "left", alignItems: 'center', width: '250px' }}>{item.descripcionaux}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '250px' }}>{item.sectorgeog}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '150px' }}>
                    <button onClick={gestionarCtaPresupuestaria(4, item.proyecto, item.auxiliar)} title='Consultar' className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i> </button>
                    <button onClick={gestionarCtaPresupuestaria(3, item.proyecto, item.auxiliar)} title='Editar' style={{ margin: 'auto 2px' }} className="btn btn-sm align-middle btn-warning rounded-circle"><i className="fas fa-edit"></i></button>
                    <button onClick={gestionarCtaPresupuestaria(2, item.proyecto, item.auxiliar)} title='Reversar' className="btn btn-sm mx-1 btn-success rounded-pill"><i className="fas fa-sync-alt"></i></button>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <PartidasExtras
        show={mostrar2}
        operacion={operacion}
        presu={presupuesto}
        presutabla={presupuestot}
        class={claspre}
        onHideCancelar={handleCancelar}
        onHideRenderizar={SeleccionarRegistros}
      />


      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

      <Dimmer active={activate} inverted>
      </Dimmer>

    </section>
  );
}
export default TablaPartidasExtras;